const seenKey = (userId: string) => `whatsNew.seen.${userId}`;

export const hasSeenWhatsNew = (userId: string) =>
  localStorage.getItem(seenKey(userId)) === '1';

export const markWhatsNewSeen = (userId: string) => {
  localStorage.setItem(seenKey(userId), '1');
};

/** Clears the once-per-login flag so the next sign-in shows the popup again. */
export const resetWhatsNewForLogin = (userId: string) => {
  localStorage.removeItem(seenKey(userId));
};
